const ConceptoPagoOptions = [
  {
    label: 'Selecciona',
    value: ''
  },
  {
    label: 'Artistas, deportistas y espectáculos públicos (1)',
    value: '1'
  },
  {
    label: 'Otras personas físicas (2)',
    value: '2'
  },
  {
    label: 'Persona moral (3)',
    value: '3'
  },
  {
    label: 'Fideicomiso (4)',
    value: '4'
  },
  {
    label: 'Asociación en participación (5)',
    value: '5'
  },
  {
    label: 'Organizaciones Internacionales o de gobierno (6)',
    value: '6'
  },
  {
    label: 'Organizaciones exentas (7)',
    value: '7'
  },
  {
    label: 'Agentes pagadores (8)',
    value: '8'
  },
  {
    label: 'Otros (9)',
    value: '9'
  }
];

export default ConceptoPagoOptions;

